import { render, staticRenderFns } from "./EmployerProfile.vue?vue&type=template&id=636f5237&"
import script from "./EmployerProfile.vue?vue&type=script&lang=js&"
export * from "./EmployerProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports